export const SPORT_TOGGLE_INPUT_LABEL = "Toggle Sports";



// WEBPACK FOOTER //
// ./src/features/director/pages/SurveyDataCenter/components/SportCheckboxes/constants.ts